// extracted by mini-css-extract-plugin
export default {"senderImageContent":"form_senderImageContent__kGGUY","imageDisplay":"form_imageDisplay__UKVEQ","label":"form_label__T3m+e","blue":"form_blue__+8WNk","red":"form_red__-GgIC"};